import { PartialTranslation } from '../translations';

export const hu: PartialTranslation = {
  newChat: 'Új beszélgetés',
  search: 'Keresés',
  user: 'Felhasználó',
  settings: 'Beállítások',
  language: 'Nyelv',
  getHelp: 'Segítség kérése',
  viewAllPlans: 'Összes terv megtekintése',
  learnMore: 'Tudj meg többet',
  logOut: 'Kijelentkezés',
  chooseLanguage: 'Nyelv választása',
  chooseYourPreferredLanguage: 'Válaszd ki a preferált nyelved',
  searchLanguages: 'Nyelvek keresése...',
  autoDetect: 'Automatikus felismerés',
  noLanguagesFound: 'Nem találhatók nyelvek',
  askAnything: 'Kérdezz bármit',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Személyes',
  freePlan: 'Ingyenes terv',
  current: 'Jelenlegi',
  close: 'Bezárás',
  archive: 'Archiválás',
  delete: 'Törlés',
  confirmDelete: 'Biztos vagy benne, hogy törölni szeretnéd ezt a beszélgetést?',
  confirmArchive: 'Biztos vagy benne, hogy archiválni szeretnéd ezt a beszélgetést?',
  deleteCannotUndo: 'Ez a művelet nem vonható vissza.',
  archiveCanFind: 'Az archiválás után megtalálhatod az archív listában.',
  
  // 资源面板
  resources: 'Erőforrások',
  addResource: 'Erőforrás hozzáadása',
  deleteResource: 'Erőforrás törlése',
  noMatchingResourcesFound: 'Nem találhatók megfelelő erőforrások',
  noResourcesAvailable: 'Nincsenek elérhető erőforrások',
  hideResources: 'Erőforrások elrejtése',
  showResources: 'Erőforrások megjelenítése',
  
  // 聊天输入框
  typeMessage: 'Üzenet beírása...',
  thinkingOptions: 'Gondolkodási lehetőségek',
  deleteFile: 'Fájl törlése',
  clearSelection: 'Kijelölés törlése',
  addAttachment: 'Melléklet hozzáadása',
  sendMessage: 'Üzenet küldése',
  
  // 思考模式选项
  deepInsight: 'Mély betekintés · Felületes elemzés',
  deepInsightDesc: 'A kulcspontok gyors megértése',
  deepExploration: 'Mély feltárás · Átfogó elemzés',
  deepExplorationDesc: 'Többdimenziós mélyreható kutatás',
  deepDeconstruction: 'Mély dekonstrukció · Rendszeres érvelés',
  deepDeconstructionDesc: 'Rétegről rétegre haladó elemzés',
  
  // 写作模式选项
  contractReview: 'Szerződés áttekintése · Kockázatazonosítás',
  contractReviewDesc: 'Záradékok elemzése és megfelelőség ellenőrzése',
  textPolish: 'Szöveg csiszolása · Szakmai kifejezés',
  textPolishDesc: 'Nyelvi optimalizálás és szerkezeti igazítás',
  legalDocuments: 'Jogi dokumentumok · Standard tervezet',
  legalDocumentsDesc: 'Jogi dokumentumok szakmai írása',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Bejelentkezés',
  register: 'Regisztráció',
  welcomeBack: 'Üdvözöljük a LawHelper-ben',
  loginSubtitle: 'Az Ön AI Jogi Kutatási Asszisztense',
  continueWithGoogle: 'Folytatás Google-lal',
  continueWithMicrosoft: 'Folytatás Microsoft-tal',
  continueWithWeChat: 'Folytatás WeChat-tel',
  orContinueWith: 'vagy folytatás a következővel',
  emailTab: 'E-mail',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Adja meg e-mail címét',
  phonePlaceholder: 'Adja meg telefonszámát',
  codePlaceholder: 'Adja meg a 6 számjegyű kódot',
  sending: 'Küldés...',
  verifying: 'Ellenőrzés...',
  verify: 'Ellenőrzés',
  sendMagicLink: 'Varázslatos link küldése',
  getVerificationCode: 'Kód kérése',
  resendCode: 'Kód újraküldése',
  resendIn: 'Újraküldés',
  magicLinkSent: 'Varázslatos link elküldve az e-mail címére',
  magicLinkHint: 'Biztonságos linket küldünk az e-mail címére',
  otpSent: 'Ellenőrző kód elküldve',
  agreeToTerms: 'A folytatással elfogadja a',
  privacyPolicy: 'Adatvédelmi irányelvek',
  termsOfService: 'Szolgáltatási feltételek',
  and: 'és',
  privacyTitle: 'Az Ön adatvédelme fontos',
  privacyIntro: 'Sütiket és hasonló technológiákat használunk a legjobb élmény biztosításához.',
  essentialCookies: 'Alapvető sütik',
  essentialDesc: 'A weboldal működéséhez szükséges',
  analyticsCookies: 'Elemző sütik',
  analyticsDesc: 'Segítenek szolgáltatásunk fejlesztésében',
  marketingCookies: 'Marketing sütik',
  marketingDesc: 'Személyre szabott tartalomhoz használjuk',
  acceptAll: 'Összes elfogadása',
  essentialOnly: 'Csak alapvetők',
  customize: 'Testreszabás',
  savePreferences: 'Beállítások mentése',
  back: 'Vissza',
  readPrivacyPolicy: 'Olvassa el adatvédelmi irányelveinket',
  cookiePolicy: 'Süti szabályzat',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI ellenőrzés',
  aiDraft: 'AI vázlat',
  smartAssistant: 'Sablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Keresés engedélyezése',
  knowledgeSearchDesc: 'AI keres a dokumentumaiban',
  clickToDisable: 'Letiltás',
  clickToEnable: 'Engedélyezés',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Erőforrás panel bezárása',
  uploading: '%{fileName} feltöltése...',
  processing: '%{fileName} feldolgozása...',
  uploadSuccess: '✓ %{fileName} feltöltve',
  uploadError: '✗ Feltöltés sikertelen: %{error}',
  quickAnswer: 'Gyors válasz',
  quickAnswerDesc: 'Gyors válasz egyszerű kérdésekre',
  cancelRequest: 'Mégse',
  library: 'Könyvtár',
  filterAll: 'Összes',
  filterChat: 'Csevegések',
  filterReview: 'Ellenőrzés',
  filterDraft: 'Vázlat',
  filterTemplate: 'Sablon',
  filterForm: 'Űrlap',
  thinking: 'Gondolkodom...',
  thinkingProcess: 'Gondolkodási folyamat',
  analyzingLegalLogic: 'Jogi logika elemzése...',
  lawhelperThinking: 'Lawhelper gondolkodik...',
  serviceError: 'Szolgáltatási hiba',
  uploaded: 'Feltöltve',
  settingsGeneral: 'Általános',
  settingsNotifications: 'Értesítések',
  settingsAppearance: 'Megjelenés',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Válasz értesítések',
  settingsResponseNotificationsDesc: 'Értesítés az AI válasz elkészüléséről',
  settingsColorMode: 'Színmód',
  settingsLight: 'Világos',
  settingsDark: 'Sötét',
  settingsSystem: 'Rendszer',
  about: 'Névjegy',
  reviewTitle: 'Dokumentum ellenőrzés',
  exitReview: 'Ellenőrzés befejezése',
  uploadPrompt: 'PDF feltöltése ellenőrzéshez',
  uploadButton: 'Fájl kiválasztása',
  startChatConfig: 'Írja be: "Ellenőrizd ezt a dokumentumot"',
  reviewPlaceholder: 'Írjon üzenetet...',
  analyzing: 'Ellenőrzés...',
  reviewComplete: 'Ellenőrzés kész',
  issuesFound: '%{count} probléma található',
  draftTitle: 'Jogi dokumentum készítése',
  draftPlaceholder: 'Szerkesszen itt vagy kérje az AI-t...',
  analyzingTemplate: 'Sablon %{name} elemzése...',
  templateAnalyzed: '✅ Sablon %{name} elemezve!',
  templateAnalysisPrompt: 'Kulcsfontosságú záradékok elemzése',
  parsingFailed: '⚠️ A fájl elemzése sikertelen.',
  generating: 'Generálás...',
  generatedSuccess: '✅ Dokumentum elkészült!',
  drafterWelcome: 'Üdvözöljük az AI dokumentum asszisztensben',
  drafterYouCan: 'Lehetőségei:',
  drafterUploadTemplate: 'Sablon feltöltése AI elemzéshez',
  drafterDescribeNeeds: 'Dokumentum igények leírása',
  drafterLetAiHelp: 'Az AI segít szerződések, megállapodások készítésében',
  drafterExamples: 'Példák:',
  drafterExampleRental: '"Készítsen bérleti szerződést"',
  drafterExampleLabor: '"Töltse ki a munkaszerződést"',
  drafterInputPlaceholder: 'Írja le igényeit...',
  drafterThinking: 'Gondolkodom...',
  drafterHistoryTitle: 'Előzmények',
  drafterNoHistory: 'Nincs előzmény',
  drafterNewChat: 'Új csevegés',
  drafterHistory: 'Előzmények',
  drafterRemoveAttachment: 'Melléklet eltávolítása',
  drafterLineHeight: 'Sormagasság',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Exportálás Word-be (.docx)',
  drafterExportPdf: 'Exportálás PDF-be',
  drafterSave: 'Dokumentum mentése',
  drafterDownload: 'Dokumentum letöltése',
  drafterUndo: 'Visszavonás',
  drafterRedo: 'Újra',
  drafterBold: 'Félkövér',
  drafterItalic: 'Dőlt',
  drafterStrike: 'Áthúzott',
  drafterUnderline: 'Aláhúzott',
  drafterHighlight: 'Kiemelés',
  drafterLink: 'Link beszúrása',
  drafterAlignLeft: 'Balra',
  drafterAlignCenter: 'Középre',
  drafterAlignRight: 'Jobbra',
  drafterAlignJustify: 'Sorkizárt',
  drafterList: 'Lista',
  drafterBulletList: 'Felsorolás',
  drafterOrderedList: 'Számozott lista',
  drafterTaskList: 'Feladatlista',
  drafterOpenResource: 'Erőforrás panel megnyitása',
  drafterStopGeneration: 'Generálás leállítása',
  drafterAgentMode: 'Ügynök mód aktív',
  drafterAgentModeOn: 'Ügynök mód aktív',
  drafterAgentModeOff: 'Normál mód',
  drafterUploadAttachment: 'Melléklet feltöltése',
  drafterExit: 'Kilépés',
  drafterConfirm: 'Megerősítés',
  drafterOpenLink: 'Link megnyitása',
  drafterDeleteLink: 'Link törlése',
  drafterQuote: 'Idézet',
  workflowTitle: 'AI munkafolyamat',
  workflowRunning: 'Fut...',
  workflowReady: 'Kész',
  workflowCompleted: 'Befejezve',
  workflowStartFailed: 'Munkafolyamat indítása sikertelen',
  workflowExecutionFailed: 'Munkafolyamat végrehajtása sikertelen',
  workflowInterrupted: 'Munkafolyamat megszakítva',
  workflowProcessing: 'Feldolgozás...',
  workflowStepsCompleted: 'lépés kész',
  workflowStepsTotal: 'Munkafolyamat kész (%{count} lépés)',
  acceptChanges: 'Változások elfogadása',
  rejectChanges: 'Változások elutasítása',
  changesAccepted: 'Változások elfogadva',
  changesRejected: 'Változások elutasítva',
  stopWorkflow: 'Leállítás',
  restartWorkflow: 'Újraindítás',
  startDrafting: 'Készítés indítása',
  interrupt: 'Leállítás',
  documentSubject: 'Dokumentum tárgya *',
  documentType: 'Dokumentum típusa',
  jurisdiction: 'Joghatóság',
  specialRequirements: 'Különleges követelmények (opcionális)',
  clickStartDrafting: 'Kattintson a "Készítés indítása" gombra',
  docTypeContract: 'Szerződés',
  docTypeAgreement: 'Megállapodás',
  docTypeNotice: 'Értesítés',
  docTypeLetter: 'Levél',
  docTypePetition: 'Kérvény',
  docTypeWill: 'Végrendelet',
  docTypePowerOfAttorney: 'Meghatalmazás',
  countryChina: 'Kína',
  countryUSA: 'Egyesült Államok',
  countryGermany: 'Németország',
  countryJapan: 'Japán',
  countryFrance: 'Franciaország',
  countryUK: 'Egyesült Királyság',
  citationVerified: 'Ellenőrizve',
  citationUnverified: 'Nem ellenőrizve',
  imageLoadFailed: 'A kép betöltése sikertelen',
  smartDocTitle: 'Intelligens dokumentum asszisztens',
  smartDocChatTitle: 'AI dokumentum asszisztens',
  smartDocDropPrompt: 'Húzza ide a PDF fájlt',
  smartDocSelectFile: 'Fájl kiválasztása',
  smartDocOr: 'vagy',
  smartDocWelcomeTitle: 'Üdvözöljük az AI asszisztensben',
  smartDocWelcomeYouCan: 'Lehetőségei:',
  smartDocUploadForAI: 'Sablon feltöltése',
  smartDocDescribeDoc: 'Igények leírása',
  smartDocLetAIDraft: 'AI segít szerződésekkel',
  smartDocExamples: 'Példák:',
  smartDocExampleRental: '"Készítsen bérleti szerződést"',
  smartDocExampleLabor: '"Töltse ki a munkaszerződést"',
  smartDocInputPlaceholder: 'Írja le igényeit...',
  smartDocRemoveAttachment: 'Melléklet eltávolítása',
  smartDocOpenResources: 'Erőforrások megnyitása',
  smartDocExit: 'Kilépés',
  reviewStartFailed: 'Ellenőrzés indítása sikertelen',
  reviewFailed: 'Ellenőrzés sikertelen',
  reviewFoundIssues: 'Ellenőrzés kész, %{count} probléma.',
  cannotReadStream: 'Nem olvasható az adatfolyam',
  parseEventFailed: 'Esemény elemzése sikertelen',
  errorPrefix: 'Hiba',
  unknownError: 'Ismeretlen hiba',
  file: 'Fájl',
  loading: 'Betöltés...',
  localFolders: 'Helyi mappák',
  selectLocalFolder: 'Helyi mappa kiválasztása',
  reselectFolder: 'Mappa váltása',
  addToContext: 'Hozzáadás a csevegéshez',
  saveFile: 'Mentés',
  renameFile: 'Átnevezés',
  fileSaved: 'Fájl mentve',
  fileRenamed: 'Fájl átnevezve: %{name}',
  browserNotSupported: 'A böngésző nem támogatja a mappa-hozzáférést',
  noFolderSelected: 'Válasszon helyi mappát',
  scanningFolder: 'Mappa vizsgálata...',
  selectFileToPreview: 'Válasszon fájlt az előnézethez',
  aiAnalyze: 'AI elemzés',
};
